/**
 * Utilidad para codificar/decodificar filtros del Explorador de Datos en la URL.
 * Permite compartir búsquedas entre usuarios vía link.
 */

const FILTER_KEYS = [
    'agencyClientId',
    'sourceType',
    'selectedItems',
    'periodState',
    'compare',
    'comparePeriod',
    'compareRange',
    'dimensions',
    'metrics',
    'dimensionsFilters',
];

/**
 * Codifica filtros en una URL compartible con query param ?q=base64
 * @param {Object} filters - Objeto con los filtros del explorador
 * @returns {string} URL completa con filtros codificados
 */
export function encodeFiltersToUrl(filters) {
    const filtered = {};
    FILTER_KEYS.forEach(key => {
        if (filters[key] !== undefined && filters[key] !== null) {
            filtered[key] = filters[key];
        }
    });

    const encoded = btoa(JSON.stringify(filtered));
    const url = new URL(window.location.href);
    url.search = '';
    url.searchParams.set('q', encoded);
    return url.toString();
}

/**
 * Decodifica filtros desde la URL actual (?q=base64)
 * @returns {Object|null} Objeto de filtros o null si no hay params
 */
export function decodeFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const q = params.get('q');
    if (!q) return null;

    try {
        const decoded = JSON.parse(atob(q));
        return decoded;
    } catch (e) {
        return null;
    }
}

/**
 * Limpia los query params de la URL sin recargar la página
 */
export function clearUrlParams() {
    const url = new URL(window.location.href);
    url.search = '';
    window.history.replaceState({}, '', url.pathname);
}
